import { lazy } from "react";

import { SolicitudesV2Layout } from "../layouts/SolicitudesV2Layout";
import RutaProtegida from "@components/RutaProtegida.tsx";
import WhiteZone from "@components/WhiteZone";

const SolicitudesV2 = lazy(() => import("@features/Solicitudes/pages/SolicitudesV2"));

export const solicitudesV2Routes = {
    element: <RutaProtegida />,
    children: [
        {
            Component: SolicitudesV2Layout,
            path: "/v2/solicitudes",
            errorElement: <WhiteZone error />,
            children: [{ index: true, Component: SolicitudesV2 }],
        },
    ],
};
